// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gZ","advertCardFooter__row":"c-a_ha","advertCardFooter__name":"c-a_hb","advertCardFooter__price":"c-a_hc","advertCardFooter__age":"c-a_he"};